// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"errors_dashboardContainer__+mZh-","MuiGrid-item":"errors_MuiGrid-item__dFgaC","MuiPaper-root":"errors_MuiPaper-root__Dpf6S"};